"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ScheduleItem_1 = require("./ScheduleItem");
class ScheduleList extends React.Component {
    constructor() {
        super(...arguments);
        this.itemsPerPage = 7;
        this.state = {
            itemsDisplayed: this.itemsPerPage
        };
        this.isMultipleOfItemsDisplayed = (index) => {
            const indexer = index + 1;
            return indexer !== 1 && (this.state.itemsDisplayed % indexer === 0);
        };
        this.handleGetMoreEvents = () => {
            if (this.props.events.length > this.state.itemsDisplayed) {
                this.setState({
                    itemsDisplayed: this.state.itemsDisplayed + this.itemsPerPage
                });
            }
        };
    }
    componentWillReceiveProps() {
        this.setState({
            itemsDisplayed: this.itemsPerPage
        });
    }
    render() {
        const { date, showTicketCount, preferredLanguage } = this.props;
        if (this.props.events === null) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("div", { className: "spinner" },
                    React.createElement("div", { className: "dot-1" }),
                    React.createElement("div", { className: "dot-2" }),
                    React.createElement("div", { className: "dot-3" }))));
        }
        if (!date) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("h2", null, "Vi har for tiden ingen filmer i programmet. Flere vil bli lagt til senere.")));
        }
        return (React.createElement("div", { className: "event-container" }, this.props.events.slice(0, this.state.itemsDisplayed).map((event, index) => (React.createElement(ScheduleItem_1.ScheduleItem, { key: index, event: event, showTicketCount: showTicketCount, isLastItem: this.isMultipleOfItemsDisplayed(index), getMoreEvents: this.handleGetMoreEvents, preferredLanguage: preferredLanguage })))));
    }
}
exports.ScheduleList = ScheduleList;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-schedule/ScheduleList.tsx